document.addEventListener('DOMContentLoaded', () => {

  const shuffleArray = (array) =>  {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }
  const positionBanners = () =>  {
    const grid = document.querySelector('.product-grid');
    const bannersTemplate = grid.querySelector('.product-banner-list');
    const showBannerEach = parseInt(bannersTemplate.dataset.showEach) || 8;
    const bannersContent = bannersTemplate.content.cloneNode(true);
    const banners = Array.from(bannersContent.querySelectorAll('.collection-grid-banner-wrapper'));
    const regularItems = Array.from(grid.querySelectorAll('.product-grid__item:not(.collection-grid-banner-wrapper)'));
    const shuffledBanners = shuffleArray(banners);
    regularItems.forEach((item , index) => {
      if(index % (showBannerEach - 1) === 0 && index > 0) {
        const banner = shuffledBanners.shift();
        if(!banner) return;
        item.after(banner);
      }
    });
  }

  positionBanners();
});